<template>
<div
  v-if="article"
  class="home blog-index-gbwhatpro blog-gbwhatpro-page page-template-default page separate-containers nav-below-header"
>
  <HeadNav selectedLanguage="en" page="blogs" :gotodownload="gotodownload" :apk="apk" />
  <GuideBreadcrumb :items="breadcrumbItems" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">

          <div class="blog-article-layout section-content">
            <article class="blog-article-card">
              <header class="blog-article-card__header">
                <h1>{{ article.h1 }}</h1>
                <p class="blog-article-card__meta">
                  <time :datetime="article.publishedAt">Published {{ publishedLabel }}</time>
                  <span v-if="article.updatedAt"> · Updated {{ updatedLabel }}</span>
                </p>
              </header>

              <figure v-if="headerCoverSrc" class="blog-article-card__cover">
                <img
                  :src="headerCoverSrc"
                  :alt="article.h1"
                  width="800"
                  height="450"
                  loading="eager"
                />
              </figure>

              <p class="blog-article-card__lead">{{ article.lead }}</p>
              <div class="blog-article-card__body article-body" v-html="bodyHtml" />

              <section v-if="article.faqs && article.faqs.length" class="blog-article-card__faq">
                <h2>Frequently Asked Questions</h2>
                <details
                  v-for="(faq, i) in article.faqs"
                  :key="i"
                  :open="i === 0"
                >
                  <summary>{{ faq[0] }}</summary>
                  <p>{{ faq[1] }}</p>
                </details>
              </section>

              <BlogPrevNext :slug="article.slug" />
            </article>
          </div>

        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/guide-pages.scss'
import '@/css/blog-gbwhatpro-index.scss'
import '@/css/blog-gbwhatpro-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import BlogPrevNext from '@/components/blog/BlogPrevNext.vue'
import blogApkMixin from '@/mixins/blogApkMixin'
import { BLOG_POSTS } from '@/constants/blogPosts'
import { formatBlogDate } from '@/utils/blog'
import { injectHeadingIds } from '@/utils/blogContent'
import { getPostCoverSrc, shouldShowHeaderCover } from '@/constants/blogCovers'
import { buildBreadcrumbs } from '@/utils/breadcrumbs'

export default {
  name: 'BlogPost',
  components: { HeadNav, GuideBreadcrumb, BlogPrevNext },
  mixins: [blogApkMixin],
  computed: {
    article() {
      const id = this.$route.meta.blogId
      return BLOG_POSTS[id] || null
    },
    parsedBody() {
      return injectHeadingIds(this.article ? this.article.body : '')
    },
    bodyHtml() {
      return this.parsedBody.html
    },
    publishedLabel() {
      return formatBlogDate(this.article.publishedAt)
    },
    updatedLabel() {
      return this.article.updatedAt ? formatBlogDate(this.article.updatedAt) : ''
    },
    headerCoverSrc() {
      if (!this.article || !shouldShowHeaderCover(this.article.slug)) return ''
      return getPostCoverSrc(this.article.slug)
    },
    breadcrumbItems() {
      return buildBreadcrumbs(this.$route.path).map((c) => ({
        label: c.label,
        href: c.to || undefined,
      }))
    },
  },
}
</script>
